// extracted by mini-css-extract-plugin
module.exports = {"snail":"style_snail__1cBMB"};